import * as React from "react";
import { Context } from "./_context";
export const CategoryTechIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 1.5c5.523 0 10 4.477 10 10v7a3 3 0 0 1-3 3h-3a1 1 0 0 1-1-1v-8l.005-.102A1 1 0 0 1 16 11.5h3c.351 0 .687.063 1 .174V11.5a8 8 0 1 0-16 0v.174c.313-.11.649-.174 1-.174h3l.103.005A1 1 0 0 1 9 12.5v8a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3v-7c0-5.523 4.477-10 10-10Zm-7 12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2v-6H5Zm12 6h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2v6Z", fill: "currentColor" }));
  return iconset[size];
};
CategoryTechIcon.iconId = "QPvamT";
